import Swal from "sweetalert2";

/**
 * Use like this:
 * component:
 * ```typescript
 * // ...
 * public rowRemoving($event: RowRemovingEvent<UserCompanyDto>) {
 * 	$event.cancel = this.rowRemovingConfirmation({
 * 		title: `Are you sure you want to delete '${$event.data.id}'?`,
 * 		text: undefined,
 * 	});
 * }
 * // ...
 * ```
 *
 * template:
 * ```html
 * <dx-data-grid
 * 	(onRowRemoving)="rowRemoving($event)"
 * >
 * ```
 *
 * @param options
 * @returns
 */
export function rowRemovingConfirmation(options: { title?: string; text?: string; }): Promise<boolean> {
	const title = options?.title ?? 'Are you sure?';
	const text = options?.text ?? undefined;

	return Swal.fire({
		title: title,
		text: text,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes, delete it!',
	}).then(result => !result.isConfirmed);
}
